module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.hotsnail.com.au","stripQueryString":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"HotSnail Mail Scanning & Forwarding","short_name":"HotSnail","start_url":"/","background_color":"#ffffff","theme_color":"#f04037","display":"standalone","icon":"static/hotsnail-vertical.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
